import React from 'react';
import { Text, View } from 'react-native';
import { formatArPhoneDisplay } from '@shared/phone';
import { modalExperience } from '../../shared/modals/modalExperience.styles';
import type { CustomerAccountRow } from '../domain/customerTypes';

type Props = {
  customer: CustomerAccountRow;
};

export function CustomerDetailContactInfo({ customer }: Props) {
  const hasContactInfo = !!(customer.phone || customer.cuit || customer.email || customer.address);
  if (!hasContactInfo) return null;

  return (
    <View style={modalExperience.detailFlatSection}>
      <Text style={modalExperience.detailBlockTitle}>Contacto</Text>
      {customer.phone ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Teléfono</Text>
          <Text style={modalExperience.detailKvValueStrong}>
            {formatArPhoneDisplay(customer.phone)}
          </Text>
        </View>
      ) : null}
      {customer.cuit ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>CUIT</Text>
          <Text style={modalExperience.detailKvValueStrong}>{customer.cuit}</Text>
        </View>
      ) : null}
      {customer.email ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Email</Text>
          <Text style={modalExperience.detailKvValueStrong}>{customer.email}</Text>
        </View>
      ) : null}
      {customer.address ? (
        <View style={modalExperience.detailKvRow}>
          <Text style={modalExperience.detailMetaLabel}>Dirección</Text>
          <Text style={modalExperience.detailKvValueStrong}>{customer.address}</Text>
        </View>
      ) : null}
    </View>
  );
}
